import Enlang from './entries/en-US';
import Trlang from './entries/tr_TR';

const AppLocale = {
  en: Enlang,
  tr: Trlang,
};

export default AppLocale;